module.exports = __webpack_public_path__ + "img/logo.7b6e3df7.png";